import React,{ useState, useEffect, useRef }  from 'react';






import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory
} from "react-router-dom";



import Home from './Home'
import MainMenu from './MainMenu'
import EditUser from './EditUser/EditSingleUser'
import ScanPaket from './ScanEtti/ScanPaket'
import UserList from './UserList/UserList'
import ShowKunde from './ShowKunde/ShowKunde'
import ShowPaket from './ShowPaket/ShowPaket'
import NeuesPaket from './ShowPaket/NeuesPaket'
import {createDB,syncDB,statusTexts} from './dexie/db'
import Maintenance from './Maintenance/Maintenance'
import RegisterScan from './Maintenance/RegisterScan';




const App = () => {

    const [syncStatus,setSyncStatus]=useState('')
    const actSyncStatus=useRef('')
    const syncError=useRef(false)
    const time= useRef(0)
    const db=useRef(null)
    const [dbRevision,setDbRevision]=useState(0) // detect changes in db and cause redraw
    const history=useHistory()




    if(!db.current)
    {
        setSyncStatus('PREPARING')
        db.current=createDB()
    }
    

     useEffect(()=>{
        const auth=localStorage.getItem('auth') 
        const sync=async ()=>
        {
            setSyncStatus('CONNECTING')
            const result =await syncDB(db.current,syncStatusChanged,auth)
            .catch(e=>console.log(e))
            .then((result)=>
            {
                time.current=0
                 console.log('initial connected',result)
            })
        }
        if((syncStatus=='PREPARING' || syncStatus==='RESYNC') && auth )
            sync()
        else if(!auth && window.location.pathname!=='/RegisterScan')
        {
            window.location.href='/RegisterScan'
        }
     

    },[db.current,syncStatus])
   
    


    const syncStatusChanged=(statusNo)=>
    {
      
        const status=statusTexts[statusNo]
        if(actSyncStatus.current!==status )
        {
            if(syncStatus !== status )
                if(status!=='SYNCING' && status !=='ONLINE' && status !=='CONNECTING')
                {
                    if(syncStatus!==status)
                        setSyncStatus(status)
                    if(status==='ERROR')
                    {
                          setSyncStatus('ERROR')
                    }
                    else
                    {
                        time.current=time.current+15
                        syncError.current=false
                    }
                }
                else
                {
                    syncError.current=false
                    if(syncStatus!=='ONLINE')
                    {
                        time.current=0
                        setSyncStatus('ONLINE')
                    }
                }
            
                    
            actSyncStatus.current=status
        }
    }


    return (
            <Router>
                <MainMenu 
                        db={db.current}
                        syncStatus={syncStatus}
                        time={time.current}
                />                
                    
        
                <Switch>

                    <Route path="/register/paket/:dienst">
                        <ScanPaket
                            db={db.current}                      
                            setSyncStatus={setSyncStatus}
                        />
                    </Route>

                        
                    <Route exact path="/new/kunde" >
                        <EditUser
                            db={db.current}
                            new={true}
                        />
                    </Route>          
                    <Route exact path="/edit/kunde/:UID" >
                        <EditUser
                            db={db.current}
                        />
                    </Route>  

                        <Route exact path="/kunden" >
                        <UserList
                            usersDB={db.current.users}
                            db={db.current}
                            dbRevision={dbRevision}

                        />
                    </Route>
                     <Route path="/show/kunde/:UID" >
                        <ShowKunde
                                db={db.current}

                        />
                    </Route>


                    <Route path="/show/paket/:PaketId" >
                        <ShowPaket
                            db={db.current}
                            />
                    </Route>                         
                
                    
                    <Route path="/new/paket" >
                        <NeuesPaket
                            db={db.current}
                        /> 
                    </Route>        
            


                    <Route exact path="/">
                        <Home
                                db={db.current}
                        />               
                    </Route> 
                    <Route exact path="/Maintenance">
                        <Maintenance
                                db={db.current}
                                syncStatusChanged={syncStatusChanged}
                        />               
                    </Route> 
                    <Route exact path="/RegisterScan">
                        <RegisterScan
                                db={db.current}
                                setSyncStatus={setSyncStatus}
                        />               
                    </Route> 


                                
                </Switch>
            </Router>

    )
}


export default App;
